class EmptyError extends Error {
  constructor(message = "No elements in sequence") {
    super(message);
    this.name = "EmptyError";
  }
}
function lastValueFrom(source, config) {
  const hasConfig = typeof config === "object";
  return new Promise((resolve, reject) => {
    let _hasValue = false;
    let _value;
    source.subscribe({
      next: (value) => {
        _value = value;
        _hasValue = true;
      },
      error: reject,
      complete: () => {
        if (_hasValue) {
          resolve(_value);
        } else if (hasConfig) {
          resolve(config.defaultValue);
        } else {
          reject(new EmptyError());
        }
      }
    });
  });
}
export {
  EmptyError,
  lastValueFrom
};
//# sourceMappingURL=lastValueFrom.js.map
